export default function RailOneWayController(
    $scope,
    $controller,
    railsFactory
) {
    'ngInject';

    $controller('RailonewayBaseController', {
        $scope,
        railsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/ukrailOnewayCtrl.js